export default __webpack_public_path__ + "static/media/paola.bd7bc5fa.png";